import { NgTemplateOutlet } from '@angular/common';
import { Component, ElementRef, input, viewChild, AfterViewInit, ChangeDetectorRef, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

type ButtonVariant = 'basic' | 'primary' | 'white';

@Component({
  selector: 'app-link',
  imports: [RouterModule, NgTemplateOutlet],
  templateUrl: './link.component.html',
  styleUrl: './link.component.css',
})
export class LinkComponent implements AfterViewInit {
  private cdr = inject(ChangeDetectorRef);

  contentRef = viewChild<ElementRef>('link');

  public href = input<string>();
  public target = input<string>('_blank');
  public routerLink = input<string>();
  public variant = input<ButtonVariant>('primary');
  protected label = '';

  ngAfterViewInit() {
    queueMicrotask(() => {
      const text = (this.contentRef()?.nativeElement?.textContent ?? '').trim();
      this.label = text ? text.slice(0, 50) : '';
      this.cdr.markForCheck();
    });
  }
}
